export default {
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      invoiceHeadTypes: [],
      invoiceReceiptMethods: [],
      invoiceHeadType: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      var _this$styleObj$invoic;
      this.invoiceHeadTypes = (_this$styleObj$invoic = this.styleObj.invoiceConfig) === null || _this$styleObj$invoic === void 0 ? void 0 : _this$styleObj$invoic.invoiceHeadType;
      if (this.invoiceHeadType == '') {
        var _this$styleObj$invoic2;
        this.invoiceHeadType = (_this$styleObj$invoic2 = this.styleObj.invoiceConfig) === null || _this$styleObj$invoic2 === void 0 ? void 0 : _this$styleObj$invoic2.invoiceHeadType[0];
      }
    });
  },
  methods: {
    invoiceHeadChange(val) {
      this.invoiceHeadType = val;
    }
  }
};